var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7879_34948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5794 4.94237L15.203 3.73167C15.0597 3.27056 14.659 2.96073 14.2062 2.96073H11.0431V1.85554C11.0431 1.30315 10.6246 0.853619 10.11 0.853619H7.21337C6.6989 0.853619 6.28028 1.30315 6.28028 1.85554V2.96073H3.11729C2.66434 2.96073 2.26367 3.27056 2.12035 3.73167L1.744 4.94237C1.6583 5.218 1.70173 5.52323 1.86 5.75895C2.01827 5.99467 2.27433 6.13549 2.54509 6.13549H2.93848L3.80433 17.6258C3.8687 18.4784 4.54286 19.1463 5.3394 19.1463H12.1597C12.9561 19.1463 13.6304 18.4784 13.6946 17.6256L14.5605 6.13549H14.7783C15.0491 6.13549 15.3051 5.99467 15.4634 5.75909C15.6217 5.52337 15.6651 5.218 15.5794 4.94237ZM7.27904 1.92546H10.0443V2.96073H7.27904V1.92546ZM12.6991 17.5392C12.6765 17.8394 12.4395 18.0745 12.1597 18.0745H5.3394C5.05954 18.0745 4.82259 17.8394 4.79996 17.5392L3.94049 6.13549H13.5585L12.6991 17.5392ZM2.75927 5.06365L3.06787 4.0708C3.0749 4.04792 3.09479 4.03256 3.11729 4.03256H14.2062C14.2287 4.03256 14.2485 4.04792 14.2556 4.0708L14.5642 5.06365H2.75927Z",
    fill: "#D4D1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1065 17.5013C11.1153 17.5019 11.124 17.502 11.1329 17.502C11.3967 17.502 11.6173 17.2801 11.6311 16.994L12.1 7.33322C12.1143 7.03763 11.9026 6.78544 11.6273 6.77009C11.3512 6.75432 11.117 6.98181 11.1026 7.2774L10.6337 16.9382C10.6194 17.2338 10.831 17.486 11.1065 17.5013Z",
    fill: "#D4D1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71476 16.9952C5.72933 17.2809 5.94963 17.502 6.21297 17.502C6.22207 17.502 6.23144 17.5017 6.24067 17.5011C6.51598 17.4851 6.72704 17.2325 6.71209 16.9369L6.2209 7.27612C6.20595 6.98053 5.97056 6.75402 5.69513 6.77021C5.41982 6.78626 5.20875 7.03886 5.22371 7.33446L5.71476 16.9952Z",
    fill: "#D4D1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66747 17.502C8.9433 17.502 9.16685 17.2621 9.16685 16.9661V7.30529C9.16685 7.00928 8.9433 6.76937 8.66747 6.76937C8.39164 6.76937 8.16809 7.00928 8.16809 7.30529V16.9661C8.16809 17.2621 8.39164 17.502 8.66747 17.502Z",
    fill: "#D4D1D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7879_34948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0455,
    height: 18.2927,
    fill: "white",
    transform: "translate(0.13623 0.853619)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconHover);
export default __webpack_public_path__ + "static/media/deleteIconHover.7261a44e0be560e676601d786155f9b6.svg";
export { ForwardRef as ReactComponent };